export enum PaymentStatusEnum {
    Unknown = 'Unknown',
    Processed = 'Processed',
    Failed = 'Failed',
    Pending = 'Pending'
}